/**
 * @returns a date string in the format of 'd MMM' (e.g. '3 Jan')
 */ const getCustomShortDateFormat = (date, locale)=>{
    const dateFormat = Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short'
    });
    return dateFormat.format(date);
};

export { getCustomShortDateFormat };
//# sourceMappingURL=get-custom-short-date-format.js.map
